import ManualSegmentCreator from "./ManualSegmentCreation";

export default ManualSegmentCreator;
